import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'
import { QuoteStatus } from 'screens/Quotes/Quotes.types'

export interface QuotesFilterValues extends FilterValues {
  keywords: string[]
  status: QuoteStatus[]
  fromDate?: Date
  toDate?: Date
}

const defaultFilters: QuotesFilterValues = {
  keywords: [],
  status: [QuoteStatus.OPEN, QuoteStatus.SUBMITTED, QuoteStatus.REJECTED],
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as QuotesViewProvider, useListView as useQuotesView }
